import { render, staticRenderFns } from "./studentParentCount.vue?vue&type=template&id=e253f20a&"
import script from "./studentParentCount.vue?vue&type=script&lang=js&"
export * from "./studentParentCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports